const headers = {
  name: "Material Request Note",
  navigate: {
    tabs: [
      {
        name: "Material Request",
        path: "/app/purchases/mrn",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;